import PlisseCalcPlisse from '../components/calc/plisse/CalcPlisse.svelte';
import PlisseCalcSlimPro from '../components/calc/plisse/CalcSlimPro.svelte';
import PlisseCalcSmart from '../components/calc/setkipro/CalcSmart.svelte';
import PlisseCalcPlugin from '../components/calc/plisse/CalcPlugin.svelte';
import PlisseCalcCommon from '../components/calc/plisse/CalcCommon.svelte';
import PlisseCalcSlim from '../components/calc/plisse/CalcSlim.svelte';
import PartMaterials from '../components/parts/Materials.svelte';
import CalcMounting from '../components/calc/CalcMounting.svelte';
import PartPrice from '../components/parts/Price.svelte';
import PlisseCalcShtory from '../components/calc/plisse/CalcPlisseShtory.svelte';
import SlimShtora from '../components/calc/plisse/CalcSlimShtora.svelte';
import SetkaShtora from '../components/calc/plisse/CalcSetkaShtora.svelte';



let list = [];
let logo = null;
let precision = null;

if (APP_TYPE === 'setkipro') {
    logo = 'setkipro.svg';

    if (location && location.href.includes('calc.plisser.pro')) {
        logo = 'plisser.png';
    }

    precision = 1;

    list.push({
        title: 'Москитная система Smart',
        calc: 'Smart',
        img: '/img/plisse/setkipro/setki.pro_smart.png',
        description: 'Профиль: 40x25 мм. Длина волны сетки: 14-16 мм. Для проёмов размеров ШхВ 1600х2500 мм',
        link: 'smart',
        component: PlisseCalcSmart,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            color: {
                'Антрацит': 'Антрацит',
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Цветной': 'Цветной',
            },
            max: {
                width: 6000,
                height: 3050
            },
            webtype: [
                'Антикошка 16 мм',
                'Антикошка 20 мм',
            ],
            recomend: {
                width: 4000,
                height: 3050
            },
            
        }
    });
    
    list.push({
        title: 'Москитная система Smart.pro',
        calc: 'Плиссе',
        img: '/img/plisse/setkipro/setki.pro_smart.pro.png',
        description: 'Профиль: 40x30 мм Длина волны сетки: 14-16 мм Для проёмов размеров ШхВ 6000х3000 мм ',
        link: 'плиссе',
        component: PlisseCalcPlisse,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            color: {
                'Антрацит': 'Антрацит',
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Цветной': 'Цветной',
            },
            max: {
                width: 6080,
                height: 3050
            },
            webtype: [
                'Обычная',
                'Антикошка',
            ],

        }
    });

    list.push({
        title: 'Москитная система Slim.pro',
        calc: 'SlimPro',
        img: '/img/plisse/setkipro/setki.pro_slim.pro.png',
        description: 'Профиль: 25x25 мм. Длина волны сетки: 14-16 мм. Для проёмов размеров ШхВ 1600х2500 мм',
        link: 'slimpro',
        component: PlisseCalcSlimPro,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,

        ],
        options: {
            color: {
                'Антрацит': 'Антрацит',
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Цветной': 'Цветной',
            },
            max: {
                width: 6000,
                height: 3050

            },
            recomend: {
                width: 2800,
                height: 2750

            },
            webtype: [
                'Обычная',
                'Антикошка',
            ],
        }
    });
    
    list.push({
        title: 'Москитная система Slim',
        calc: 'Slim',
        img: '/img/plisse/setkipro/setki.pro_slim.png',
        description: 'Профиль: 25x18 мм. Длина волны сетки: 12-14 мм. Для проёмов размеров ШхВ 1000х2000 мм',
        link: 'slim',
        component: PlisseCalcSlim,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,

        ],
        options: {
            color: {
                'Антрацит': 'Антрацит',
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Цветной': 'Цветной',
            },
            max: {
                width: 4000,
                height: 2250
            },
            webtype: [
                'Обычная',
                'Антикошка',
            ],
            recomend: {
                width: 2100,
                height: 2250

            },
        }
    });


    list.push({
        title: 'Штора в рамке',
        calc: 'Штора в рамке',
        img: '/img/plisse/setkipro/setki.pro_slim.png',
        description: 'Профиль: 25x18 мм. Длина волны сетки: 12-14 мм. Для проёмов размеров ШхВ 1000х2000 мм',
        link: 'slimshtora',
        component: SlimShtora,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,

        ],
        options: {
            color: {
                'Антрацит': 'Антрацит',
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Цветной': 'Цветной',
            },
            max: {
                width: 4000,
                height: 2250
            },

            shtoryPoluprozcolor: [
                'белая',
                'серая',
                'кремовая',
                'бежевая',
                'сине-зеленый',
                'мокко',
                'темно-оливковый',
                'черный',
                'антрацит',
            ],

            nitcolor:   [
                'белая',
                'серая',
                'кремовая',
                'бежевая',
                'сине-зеленый',
                'мокко',
                'темно-оливковый',
                'антрацит',
            ],
            recomend: {
                width: 2100,
                height: 2250

            },
        }
    });




    list.push({
        title: 'Шторы плиссе',
        calc: 'Шторы плиссе',
        img: '/img/plisse/PlisseShtory.jpeg',
        description: 'Плиссированные ткани, между двумя профилями.',
        link: 'шторы-плиссе',
        component: PlisseCalcShtory,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            max: {
                width: 2400,
                height: 4000
            },
            recomend: {
                width: 1200,
                height: 2500

            },

            shtoryPoluprozcolor: [
                'белая',
                'серая',
                'кремовая',
                'бежевая',
                'сине-зеленый',
                'мокко',
                'темно-оливковый',
                'черный',
                'антрацит',
            ],

            nitcolor:   [
                'белая',
                'серая',
                'кремовая',
                'бежевая',
                'сине-зеленый',
                'мокко',
                'темно-оливковый',
                'антрацит',
            ],
        }
    });


    list.push({
        title: 'Сетка-штора',
        calc: 'Сетка-штора',
        img: '/img/plisse/PlisseShtory.jpeg',
        description: 'Сетка-штора',
        link: 'сетка-штора',
        component: SetkaShtora,
        components: [
            PartPrice,
            CalcMounting,
            PartMaterials,
        ],
        options: {
            max: {
                width: 2400,
                height: 4000
            },
            recomend: {
                width: 1200,
                height: 2500

            },

            shtoryPoluprozcolor: [
                'белая',
                'серая',
                'кремовая',
                'бежевая',
                'сине-зеленый',
                'мокко',
                'темно-оливковый',
                'черный',
                'антрацит',
            ],

            nitcolor:   [
                'белая',
                'серая',
                'кремовая',
                'бежевая',
                'сине-зеленый',
                'мокко',
                'темно-оливковый',
                'антрацит',
            ],
        }
    });
    
    list.push({
        title: 'Москитная сетка Вставная',
        calc: 'Вставная',
        img: '/img/plisse/setkipro/setki.pro_vstavnaya.png',
        description: 'Профиль: 30x25 мм. Для окон размеров 1000х2100 мм',
        link: 'вставная',
        component: PlisseCalcPlugin,
        components: [
            PartPrice,
            PartMaterials,

        ],
        options: {
            color: {
                'Антрацит': 'Антрацит',
                'Анодированный(коньяк)': 'Анодированный(коньяк)',
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Цветной': 'Цветной',
            },
            max: {
                width: 1300,
                height: 2200
            }
        }
    });
    
    list.push({
        title: 'Москитная сетка Эконом',
        calc: 'Обычная',
        img: '/img/plisse/setkipro/setki.pro_econom.png',
        description: 'Профиль: 25x19 мм. Для окон размеров 900х1800 мм',
        link: 'обычная',
        component: PlisseCalcCommon,
        components: [
            PartPrice,
            PartMaterials,

        ],
        options: {
            color: {
                'Белый': 'Белый',
                'Коричневый(RAL8017)': 'Коричневый(RAL8017)',
                'Антрацит': 'Антрацит',
                'Цветной': 'Цветной',
            },
            max: {
                width: 1000,
                height: 2100
            }
        }
    });
}

export {list, logo, precision};
